<template>
  <v-app>
    <update-password v-if="updatePassword"></update-password>
    <app-auth v-else-if="!authState"></app-auth>
    <set-totp v-else-if="authState && setupTotp"></set-totp>
    <veryfy-totp v-else-if="authState && verifyTotp"></veryfy-totp>
    <v-row v-else-if="userLoading">
        <v-dialog
        v-model="userLoading"
        hide-overlay
        persistent
        width="300"
        >
        <v-card
            color="primary"
            dark
        >
            <v-card-text>
            Please stand by
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
            </v-card-text>
        </v-card>
        </v-dialog>
    </v-row>
    <approval-check v-else-if="!approval"></approval-check>
    <app-layout v-else-if="authState"></app-layout>
  </v-app>
</template>

<script>
// import { supabase } from './supabase';
import Layout from './views/Layout.vue'
import Auth from './views/Auth.vue'
import ApprovalCheck from './components/ApprovalCheck.vue';
import UpdatePassword from './views/UpdatePassword.vue';
import SetTotp from './components/SetTotp.vue';
import VeryfyTotp from './components/VeryfyTotp.vue';
export default {
name: 'App',

data: () => ({
}),
methods: {

},
components: {
    AppLayout: Layout,
    AppAuth: Auth,
    ApprovalCheck,
    UpdatePassword,
    SetTotp,
    VeryfyTotp
},
computed: {
  authState () {
    return this.$store.getters.loggedIn 
  },
  approval() {
    let user = this.$store.getters.loadedUser
    if(!user) {
      return true
    }
    if(user.status == 'PENDING') {
      return false
    } else {
      return true
    }
  },
  userLoading () {
    return this.$store.getters.loadedUserLoading
  },
  updatePassword() {
    return this.$store.getters.updatePassword
  }, 
  setupTotp() {
    return this.$store.getters.setupTotp
  },
  verifyTotp() {
    return this.$store.getters.verifyTotp
  }
},
mounted() {
  const currentRoute = this.$route.path;
  const currentParams = this.$route.params;
  console.log('Current route:', currentRoute);
  console.log('Route params:', currentParams);
  if (currentRoute === '/update-password') {
    this.$store.commit('SET_UP', true);
  } else {
    this.$store.commit('SET_UP', false)
  }
},  

};
</script>

<style>
  .gradient-button {
    background: linear-gradient(45deg, #053cdf, #00c7ff);
    color: white !important; /* override text color if needed */
  }
  .gradient-bg {
    background: linear-gradient(45deg, #00c7ff, #053cdf);
    color: white !important; /* override text color if needed */
  }
  .gradient-button:hover {
    background: linear-gradient(45deg, #00c7ff, #053cdf);
  }
  .gradient-button:focus {
    outline: none;
  }
  .gradient-button:active {
    transform: scale(0.95);
  }
  .gradient-button:disabled {
    background: linear-gradient(45deg, #053cdf, #00c7ff);
    opacity: 0.5;
  }
  /* src/styles/global.css or App.vue <style> block */
body {
  font-family: 'Poppins', sans-serif;
}

.v-application {
  font-family: 'Poppins', sans-serif;
}

/* In your <style> block or global CSS */
.no-select {
  user-select: none;
  -webkit-user-select: none; /* Chrome, Safari */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;     /* IE/Edge */
}

table{
    border-radius: 20%;
}

tbody{
    background-color: rgba(255, 255, 255, 0.5);
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  text-align: center;
  color: #f0f7ff !important;
  font-weight: 1300;
  font-size: 15px;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    text-align: center;
    color: #00173b;
    font-size: 13px;
}
.datat thead {
    text-align: center;
    background-color: #011C3A;
    border-radius: 8px;
    
}

tr {
  transition: box-shadow 0.2s ease-in-out;
}

.datat tr:hover {
  /* transform: scale(1.005); */
  cursor: pointer;
  box-shadow: #053cdf 0px 0px 10px 2px;
}
.blur-row td {
  filter: blur(7px);
  pointer-events: none;
}

.datat tr:hover td {
  background: #013ee510;
  color: white;
}

</style>
